import { Injectable, inject } from '@angular/core'
import { RestClientPaged } from '@elderbyte/ngx-starter'
import { ShopfloorLayoutSpec } from './shopfloor-layout-spec'
import { HttpClient } from '@angular/common/http'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { environment } from '../../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class ShopfloorLayoutSpecService extends RestClientPaged<ShopfloorLayoutSpec, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger('ShopfloorLayoutSpecService')

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/shop-floor/layouts', http, {
      idField: 'facility',
    })
  }
}
